import React from 'react';
import { Dropdown } from '@balance-web/dropdown-v2';

import { AppHeader } from '@reckon-web/app-header';

import { useRouter } from '../../../services/Navigation';
import { Config } from '../../../services/Config';
import { useAuth, useAuthenticatedUser } from '../../../services/Auth';

export function SiteHeaderContainer() {
  const router = useRouter();
  const { logout } = useAuth();
  const { user } = useAuthenticatedUser();

  /**
   * TODO: if your app needs to
   */
  const handleHelpClick = () => {
    router.push(Config.APPLICATION_GENERAL_HELPARTICLE_URL);
  };

  return (
    <AppHeader
      appIconUrl={Config.APPLICATION_LOGO_URL}
      appName="Payroll"
      appVersion={Config.APPLICATION_VERSION}
      globalActions={<></>}
      pages={[]}
      selectedPage={router.asPath}
      userMenu={
        (!!user && {
          userFullName: user.fullName,
          userEmail: user.email || '',
          items: (
            <React.Fragment>
              <Dropdown.Item value="help" onSelect={handleHelpClick}>
                Help & Support
              </Dropdown.Item>
              <Dropdown.Item
                value="signout"
                onSelect={() => {
                  logout({ reasonCode: 'USER_INITIATED' });
                }}
              >
                Sign out
              </Dropdown.Item>
            </React.Fragment>
          ),
        }) ||
        undefined
      }
    />
  );
}
